<template>
    <div class="content">
      <div class="container-fluid">
        <div class="row mt-3">
          <div class="col-12">
            <card class="strpied-tabled-with-hover"
                  body-classes="table-full-width table-responsive"
            >
              <template slot="header">
                <b-row>
                  <b-col lg="2" class="mt-4">
                    <b-button class="btn-primary" @click="toggleFilters">{{ showFilters ? 'Hide Filters' : 'Filter' }}</b-button>
                  </b-col>
                  <b-col lg="1" class="mt-4">
                    <b-button-toolbar key-nav aria-label="Toolbar with button groups">
                      <b-button-group class="mx-1">
                        <b-button style="padding: 5px 6px !important;" @click="getDataForExcel()" :title="translate('exportToExcel')"><b-icon icon="file-earmark-excel-fill"></b-icon></b-button>
                        <b-button style="padding: 5px 6px !important;" @click="getDataForPDF()" :title="translate('exportToPdf')"><b-icon icon="file-earmark-pdf-fill"></b-icon></b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </b-col>
                </b-row>
                <b-collapse v-model="showFilters">
                  <b-row class="mt-3">
                    <b-col lg="2">
                      <label class="some-label" for="select-building">{{ translate('association') }}</label>
                      <b-form-select id="select-building" v-model="selectedAssociationType" :options="assocationTypeOptions"></b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <label class="some-label" for="select-status">{{ translate('paymentStatusForThisMonth') }}</label>
                      <b-form-select id="select-status" v-model="selectedStatus" :options="statusOptions"></b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <label class="some-label" for="select-completion-status">{{ translate('completionStatus') }}</label>
                      <b-form-select id="select-completion-status" v-model="selectedCompletionStatus" :options="completionStatusOptions"></b-form-select>
                    </b-col>
                    <b-col lg="2">
                      <label class="some-label" for="phone-number">{{ translate('phoneNumber') }}</label>
                      <div class="input-group">
                        <span class="input-group-text">+251</span>
                        <b-form-input 
                          id="phone-number" 
                          v-model="phoneNumber"  
                          :placeholder="translate('phoneNumber')" 
                          type="tel"
                          maxlength="9">
                        </b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col lg="2">
                      <b-button class="btn-secondary" @click="getReport()">{{ translate('find') }}</b-button>
                    </b-col>
                    <b-col lg="2">
                      <b-button class="btn-outline-secondary" @click="clearFilters">Clear</b-button>
                    </b-col>
                  </b-row>
                </b-collapse>
              </template>
              <div class="table-container">
              <b-table-simple
                :small="true"
                sticky-header
                style="max-height: 395px;"
                striped
                responsive
                hover
              >
                <b-thead class="sticky-header">
                  <b-tr>
                    <b-th>{{ translate('no') }}</b-th>
                    <b-th>{{ translate('association') }}</b-th>
                    <b-th>{{ translate('associationType') }}</b-th>
                    <b-th>{{ translate('contributionAmount') }}</b-th>
                    <b-th>{{ translate('memberName') }}</b-th>
                    <b-th>{{ translate('memberPhone') }}</b-th>
                    <b-th>{{ translate('paymentId') }}</b-th>
                    <b-th>{{ translate('Drawn') }}</b-th>
                    <b-th>{{ translate('savingStartDate') }}</b-th>
                    <b-th>{{ translate('totalMember') }}</b-th>
                    <b-th>{{ translate('paymentStatus') }}</b-th>
                    <b-th>{{ translate('completionStatus') }}</b-th>
                    <b-th>{{ translate('totalCollectedAmount') }}</b-th>
                    <b-th>{{ translate('totalServiceFee') }}</b-th>
                  </b-tr>
                </b-thead>
                <template v-if="spinner">
                    <b-tbody class="text-center">
                      <b-tr >
                          <b-td colspan="9" class="text-center" style="display: table-cell">
                            <b-spinner
                            style="height: 3rem; width: 3rem;"
                              variant="warning"
                            ></b-spinner>
                          </b-td>
                        </b-tr>
                    </b-tbody>
                </template>
                <template v-else>
                  <template v-if="filterTable.length === 0" >
                  <b-tbody>
                    <b-tr>
                        <b-td colspan="8" class="text-center">{{ translate('nothingFound') }}</b-td>
                        <b-td></b-td>
                      </b-tr>
                      </b-tbody>
                  </template>
                  <template v-else>
                  <b-tbody>
                    <b-tr
                      v-for="(item, index) in filterTable"
                      :key="item.ID"
                    >
                        <b-td>{{(currentPage - 1) * perPage + index + 1}}</b-td>
                        <b-td>{{item.association}}</b-td>
                        <b-td>{{formatAssociationType(item.associationType)}}</b-td>
                        <b-td>{{item.amountPerPerson}}</b-td>
                        <b-td>{{item.memberName}}</b-td>
                        <b-td>{{item.memberPhone}}</b-td>
                        <b-td>{{item.uniqueId}}</b-td>
                        <b-td>{{item.isTaking}}</b-td>
                        <b-td>{{item.savingStartDate}}</b-td>
                        <b-td>{{numberWithCommas(item.numberOfMember)}}</b-td>
                        <b-td>{{item.paymentStatus}}</b-td>
                        <b-td>{{item.completionStatus}}</b-td>
                        <b-td>{{numberWithCommas(item.totalCollectedAmount)}}</b-td>
                        <b-td>{{numberWithCommas(item.totalCollectedServiceFee)}}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-td colspan="8" class="text-right" style="font-weight: bold;">{{ translate('totalCollectedPayment') }}</b-td>
                      <b-td style="font-weight: bold;">{{numberWithCommas(totalAllCollectedAmount)}}</b-td>
                    </b-tr>
                    <b-tr>
                      <b-td colspan="8" class="text-right" style="font-weight: bold;">{{ translate('totalCollectedFeePayment') }}</b-td>
                      <b-td style="font-weight: bold;">{{numberWithCommas(totalAllCollectedServiceFee)}}</b-td>
                    </b-tr>
                </b-tbody>
                  </template>
                </template>
              </b-table-simple>
            </div>
                <!-- Pagination outside the table to prevent overlap -->
            <div class="pagination-container">
              <b-row class="mt-3 align-items-center justify-content-between">
                <b-col class="d-flex align-items-center">
                  <label class="mr-2 mb-0">{{ translate('recordsPerPage') }}</label>
                  <b-form-select
                    id="input-horizontal"
                    class="custom-dropdown"
                    v-model="perPage"
                    :options="pageOptions"
                    @change="changePerPage"
                  >
                  </b-form-select>
                </b-col>
                <b-col class="d-flex justify-content-end">
                  <b-pagination
                    v-model="currentPage"
                    :per-page="perPage"
                    :total-rows="totalRows"
                    @page-click="changePage"
                    align="right"
                  />
                </b-col>
              </b-row>
            </div>
             </card>
          </div>
        </div>
      </div>
    </div>
  </template>
  <script>
    import LTable from 'src/components/Table.vue'
    import Card from 'src/components/Cards/Card.vue'
    import jsPDF from 'jspdf'
    import 'jspdf-autotable';
    import autoTable from "jspdf-autotable";
    import { setLanguage, translate } from 'src/i18n.js';
    export default {
      components: {
        LTable,
        Card
      },
      data () {
        return {
          showFilters: false,
          totalRows: 0,
          currentPage: 1,
          perPage: 5,
          pageOptions: [
            {value: 7, text: 7},
            {value: 10, text: 10},
            {value: 25, text: 25},
            {value: 50, text: 50},
            {value: 100, text: 100}
          ],
          items: [],
          filter: "",
          DateFrom: "",
          DateTo: "",
          phoneNumber: '',
          statusOptions:[
            {text: translate('all'), value: "All"},
            {text: "Paid", value: "Paid"},
            {text: "Unpaid", value: "Unpaid"}
          ],
          completionStatusOptions:[
            {text: translate('all'), value: "All"},
            {text: "Not Completed", value: "NotCompleted"},
            {text: "Completed", value: "Completed"}
          ],
          selectedCompletionStatus: "All",
          selectedAssociationType: "All",
          assocationTypeOptions: [
            {text: translate('all'), value: "All"},
          ],
          selectedStatus: "All",
          DateFrom: "",
          DateTo: "",
          dataExcel: [],
          priceOptions: [
            {value:"PerSquareMeter", text: "Per Square Meter"},
            {value:"PerMonth", text: "Monthly"}
          ],
          totalAllCollectedAmount: 0.0,
          totalAllCollectedServiceFee:0.0,
          spinner: true
        }
      },
      computed: {
        filterTable() {
          var searchItems = this.items;
          var searchString = this.filter;
          if (searchString === "") {
            return searchItems;
          }
          searchString = searchString.trim().toLowerCase();
  
          searchItems = searchItems.filter(function (item) {
            if (item.buildingName.toLowerCase().indexOf(searchString) !== -1 || item.status.toString().toLowerCase().indexOf(searchString) !== -1   || (String(item.floor).toLowerCase() + " - " + item.roomNumber.toLowerCase()).indexOf(searchString) !== -1) {
              return item;
            }
          });
          return searchItems;
        },
      },
       mounted() {
        this.getReport();
        this.getEkubType();
        this.$on("AfterComplete", () => {
          this.getReport();
        });
      },
      methods: {
        translate,
      changeLanguage(lang) {
        setLanguage(lang);
        this.$forceUpdate();
      },
        getEkubType(){
           this.$store.dispatch('getEkubsByOwnerID',{userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID"))})
          .then(response=>{
              Array.from(response.data).forEach((value) => {
              this.assocationTypeOptions.push({
                value: value.id,
                text: value.ekubName
              });
            });
          })
          .catch(error=>{
              this.$notify({
                  title: 'Error',
                  text: error.response.data,
                  type: 'error'
              })
          })
        },
        numberWithCommas(x) {
          if(x !== null && x !== undefined ){
              x= parseFloat(x);
              x = x.toFixed(2);
              return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          }else{
            return null;
          }
        },
        getOptionPrice(option){
          if(option != undefined){
            if(option === null) return "";
            else return this.priceOptions.filter(x=>x.value == option)[0].text;
          }else{
            return "";
          }
        },
        toggleFilters() {
          this.showFilters = !this.showFilters;
        },
        clearFilters() {
          this.selectedAssociationType = "All";
          this.selectedStatus = "All";
          this.selectedCompletionStatus = "All";
          this.phoneNumber = '';
          this.getReport();
        },
        formatAssociationType(type) {
          return type === "Group" ? "Association" : type;
        },
        getReport(){
          this.spinner = true;
          
          // Build request object for unified API
          const requestData = {
            userId: parseInt(sessionStorage.getItem("ID")),
            superUserId: parseInt(sessionStorage.getItem("superID")),
            page: this.currentPage,
            line: this.perPage
          };

          // Add optional filters
          if (this.selectedAssociationType !== "All") {
            requestData.ekubId = this.selectedAssociationType;
          }
          if (this.selectedStatus !== "All") {
            requestData.paymentStatus = this.selectedStatus;
          }
          if (this.selectedCompletionStatus !== "All") {
            requestData.completionStatus = this.selectedCompletionStatus;
          }
          if (this.phoneNumber !== "") {
            requestData.phoneNumber = "+251" + this.phoneNumber;
          }

          this.$store.dispatch('getReportsUnifiedForAdmin', requestData)
            .then(response => {
              this.items = response.data.reports;
              this.totalRows = response.data.totalElements;
              this.totalAllCollectedServiceFee = response.data.totalAllCollectedServiceFee;
              this.totalAllCollectedAmount = response.data.totalAllCollectedAmount;
            })
            .catch(error => {
              console.log(error);
            })
            .finally(() => {
              this.spinner = false;
            });
        },
        changePage(event, page){
          this.currentPage = page;
          this.getReport();
        },
        changePerPage(event){
          this.currentPage = 1; // Reset to first page when changing per page
          this.getReport();
        },
        async getDataForExcel(){
          this.dataExcel =[];
          if(this.selectedStatus === "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus === "All" && this.phoneNumber === ""){
            await this.$store.dispatch('getReportsForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.selectedStatus === "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus === "All"){
            await this.$store.dispatch('getReportsByEkubForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, ekubId: this.selectedAssociationType})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.selectedStatus !== "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus === "All" ){
            await this.$store.dispatch('getReportsByPaymentStatusForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.selectedStatus === "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus !== "All"){
            await this.$store.dispatch('getReportsByCompletionStatusForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, completionStatus: this.selectedCompletionStatus})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.selectedStatus === "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus !== "All"){
            await this.$store.dispatch('getReportsByCompletionStatusandEkubForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, completionStatus: this.selectedCompletionStatus, ekubId: this.selectedAssociationType})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.selectedStatus !== "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus === "All"){
            await this.$store.dispatch('getReportsByPaymentStatusandEkubForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus, ekubId: this.selectedAssociationType})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.selectedStatus !== "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus !== "All"){
            await this.$store.dispatch('getReportsByCompletionStatusAndPaymentStatusForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus, completionStatus:this.selectedCompletionStatus})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.selectedStatus !== "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus !== "All"){
            await this.$store.dispatch('getReportsByCompletionStatusandPaymentStatusAndEkubForUser', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus, completionStatus:this.selectedCompletionStatus, ekubId: this.selectedAssociationType})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else if(this.phoneNumber !== "" ){
            await this.$store.dispatch('getReportByPhoneNumberForSuper', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows,phoneNumber: "+251"+this.phoneNumber})
            .then( async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                 this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                // this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }else{
            await this.$store.dispatch('getReportByPhoneNumber', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows})
            .then(async response=>{
              if(response.data.reports.length > 0){
                var index=0;
                Array.from(response.data.reports).forEach(x=>{
                  index++;
                  this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_Start_Date: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Cycle : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
                  })
                })
                this.totalRows = response.data.totalElements;
              }
            })
            .catch(error=>{
                // this.$notify({
                //     title: 'Error',
                //     text: error.response.data,
                //     type: 'error'
                // })
                console.log(error);
            })
          }
          if(this.dataExcel.length > 0){
            const filename = 'Report for Equb Member.csv';
            const csvData = await this.convertToCSV(this.dataExcel);
            const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8;' });
    
            if (navigator.msSaveBlob) { // IE 10+
              navigator.msSaveBlob(blob, filename);
            } else {
              const link = document.createElement('a');
              if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', filename);
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
              }
            }
          }else{
              this.$notifications.notify(
                  {
                    message: "Nothing to export",
                    horizontalAlign: 'center',
                    verticalAlign: 'top',
                    type: 'danger'
                  })
          }
        },
        async convertToCSV(jsonData) {
          const header = Object.keys(jsonData[0]).join(',');
          const rows = jsonData.map(row => Object.values(row).join(','));
          return `\ufeff${header}\n${rows.join('\n')}`;
        },
    async getDataForPDF() {
    this.dataExcel = [];
    this.spinner = true;
  
    try {
      let response;
  
      if(this.selectedStatus === "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus === "All" && this.phoneNumber === ""){
        response = await this.$store.dispatch('getReportsForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows });
      }else if(this.selectedStatus === "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus === "All"){
        response = await this.$store.dispatch('getReportsByEkubForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, ekubId: this.selectedAssociationType });
      }else if(this.selectedStatus !== "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus === "All" ){
        response = await this.$store.dispatch('getReportsByPaymentStatusForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus });
      }else if(this.selectedStatus === "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus !== "All"){
        response = await this.$store.dispatch('getReportsByCompletionStatusForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, completionStatus: this.selectedCompletionStatus });
      }else if(this.selectedStatus === "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus !== "All"){
        response = await this.$store.dispatch('getReportsByCompletionStatusandEkubForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, completionStatus: this.selectedCompletionStatus , ekubId: this.selectedAssociationType});
      }else if(this.selectedStatus !== "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus === "All"){
        response = await this.$store.dispatch('getReportsByPaymentStatusandEkubForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus , ekubId: this.selectedAssociationType});
      }else if(this.selectedStatus !== "All" && this.selectedAssociationType === "All" && this.selectedCompletionStatus !== "All"){
        response = await this.$store.dispatch('getReportsByCompletionStatusAndPaymentStatusForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus, completionStatus:this.selectedCompletionStatus});
      }else if(this.selectedStatus !== "All" && this.selectedAssociationType !== "All" && this.selectedCompletionStatus !== "All"){
        response = await this.$store.dispatch('getReportsByCompletionStatusandPaymentStatusAndEkubForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows, paymentStatus: this.selectedStatus, completionStatus:this.selectedCompletionStatus, ekubId: this.selectedAssociationType});
      }else if(this.phoneNumber !== "" ){
        response = await this.$store.dispatch('getReportByPhoneNumber', {userId: sessionStorage.getItem("ID"),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.perPage,phoneNumber: "+251"+this.phoneNumber})
      } else {
        response = await this.$store.dispatch('getReportsForUser', { userId: parseInt(sessionStorage.getItem("ID")),superUserId: parseInt(sessionStorage.getItem("superID")), page: 1, line: this.totalRows });
      }
      if (response.data.reports.length > 0) {
        let index = 0;
  
        response.data.reports.forEach(x => {
          index++;
  
          this.dataExcel.push({
                    No: index,
                    Association: x.association,
                    Association_Type: x.associationType,
                    Number_Of_Member: x.numberOfMember,
                    Saving_StartDate: x.savingStartDate,
                    Completion_Status : x.completionStatus==="NotCompleted"? "Not Completed": "Completed",
                    Amount_Per_Person : x.amountPerPerson,
                    Member_Name : x.memberName,
                    Member_Phone: x.memberPhone,
                    Next_Payment_Date: x.nextPaymentDueDate,
                    Payment_Status: x.paymentStatus,
                    Drawing_Wins: x.isTaking,
                    Total_Collected_Amount: x.totalCollectedAmount,
                    Total_Collected_Service_Fee: x.totalCollectedServiceFee,
          });
        });
  
        if (this.dataExcel.length > 0) {
                const pdf = new jsPDF({
                    orientation: 'landscape'
                });

                // Load custom font
                try {
                    pdf.addFileToVFS(NotoSansEthiopic);
                    pdf.addFont(NotoSansEthiopic, NotoSansEthiopic);
                    pdf.setFont(NotoSansEthiopic);
                } catch (fontError) {
                    pdf.setFont("helvetica");
                }

                pdf.setFontSize(10);

                let headers = [
                    "No",
                    "Association",
                    "Association Type",
                    "Number Of Member",
                    "Saving StartDate",
                    "Completion Status",
                    "Amount Per Person",
                    "Member Name",
                    "Member Phone",
                    "Next Payment Date",
                    "Payment Status",
                    "Drawing Wins",
                    "Total Collected Amount",
                    "Total Collected Service Fee"
                ];

                let rows = this.dataExcel.map(obj => Object.values(obj));

                // Add Table to PDF
                autoTable(pdf, {
                    head: [headers],
                    body: rows,
                    styles: {
                        fontSize: 6,
                        font: "NotoSansEthiopic",
                        fontStyle: "normal"
                    },
                    headStyles: {
                        fillColor: [37, 91, 48],
                        textColor: [240, 206, 13],
                        fontSize: 6.6,
                        font: "NotoSansEthiopic",
                        fontStyle: "normal"
                    },
                    // columnStyles: {
                    //     0: { cellWidth: 10 },
                    //     1: { cellWidth: 30 },
                    //     2: { cellWidth: 30 },
                    //     3: { cellWidth: 30 },
                    //     4: { cellWidth: 30 },
                    //     5: { cellWidth: 30 },
                    //     6: { cellWidth: 30 },
                    //     7: { cellWidth: 30 },
                    //     8: { cellWidth: 30 },
                    //     9: { cellWidth: 30 },
                    //     10: { cellWidth: 30 },
                    //     11: { cellWidth: 30 },
                    //     12: { cellWidth: 30 },
                    //     13: { cellWidth: 30 }
                    // }
                });

                // Save the PDF
                pdf.save("Report_for_Members.pdf");
            }  else {
          this.$notifications.notify({
            message: "No data to export",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          });
        }
      }
    } catch (error) {
      console.log(error);
      this.$notifications.notify({
        message: "An error occurred while generating the PDF",
        horizontalAlign: 'center',
        verticalAlign: 'top',
        type: 'danger'
      });
    } finally {
      this.spinner = false;
    }
  },
        clearData(){
          this.$emit('AfterComplete');
        }
      }
    }
  </script>
  <style>
  .text-warning {
      color: rgba(240, 206, 13, 0.937) !important;
  }
  .table-container {
  display: flex;
  flex-direction: column;
  max-height: calc(80vh - 0px); /* Adjust depending on other UI elements */
  overflow-y: auto;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* Mobile adjustments */
@media (max-width: 768px) {
  .custom-dropdown {
    max-width: 100%; /* Ensure dropdown expands on mobile */
  }

  .pagination-container {
    margin-top: 20px;
  }

  .table-container {
    max-height: 50vh; /* Lower height for better mobile usability */
  }

  .b-button-toolbar {
    flex-wrap: wrap;
    justify-content: flex-start;
  }

  .b-button {
    padding: 8px;
    margin: 5px;
  }
  .table-container {
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: auto;
}
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff; /* Ensure header has a background */
  z-index: 1; /* Ensure it stays on top of the table body */
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1); /* Optional: Add shadow for better visibility */
}
  </style>
  